var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('apollo-query',{staticClass:"grow flex flex-row",attrs:{"query":_vm.getRecorderPostQuery,"variables":{id: _vm.id}},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var ref_result = ref.result;
var error = ref_result.error;
var data = ref_result.data;
var isLoading = ref.isLoading;
var query = ref.query;
return [(isLoading)?_c('loading'):_vm._e(),(!isLoading)?_c('apollo-query',{staticClass:"grow flex flex-row",attrs:{"query":_vm.getGameQuery,"variables":{id:data.getPost.game}},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var ref_result = ref.result;
var error = ref_result.error;
var data = ref_result.data;
var isLoading = ref.isLoading;
var query = ref.query;
return [(isLoading)?_c('loading'):_vm._e(),(!isLoading)?_c('runner-game',{ref:"runnerGame",staticClass:"w-full h-full",attrs:{"gamedata":_vm.getGamedata(data.getGame),"user":_vm.pbcUser,"data":{},"enable-watermark":_vm.watermarked,"override-aspect":_vm.overrideAspect},on:{"game-started":_vm.onGameStarted,"looped":_vm.onLooped}}):_vm._e()]}}],null,true)}):_vm._e()]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }